import { colors } from '@flowwai-frontend/shared/style-guide'

export const pipelineEventsTheme = {
   // #region - light theme config
   light: {
      pipelineEvents: {
         plusIconColor: colors['base-white'],
         headerBorderColor: 'border-gray-300',
         headerTextColor: 'text-gray-900',
         eventNameTextColor: 'text-gray-700',
         templateNameTextColor: 'text-gray-700',
         createdAtTextColor: 'text-gray-600',
         pipelineEventsContainerBgColor: 'bg-gray-100',
         createPipeline: {
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-600'
         },
         chevronLeftIconColor: colors['primary-600']
      },
      leadStageField: {
         customOptionHoverBgColor: 'hover:bg-gray-50',
         focusBgColor: 'bg-gray-50',
         selectedBgColor: 'bg-gray-50',
         customOptionTextColor: 'text-gray-900'
      },
      pipelineEventTemplate: {
         checkIconColor: colors['gray-700']
      }
   },
   // #endregion

   // #region - light theme config
   dark: {}
   // #endregion
}
